"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PIDS = exports.MS_PER_EPOCH = exports.LAMPORTS_PER_EPOCH = exports.LIFETIME_CONSTRUCTION_ACCOUNT_MS = exports.LIFETIME_RESULT_ACCOUNT_MS = exports.LIVE_N_EPOCHS = exports.CONSTRUCTION_ACCOUNT_SIZE = void 0;
exports.CONSTRUCTION_ACCOUNT_SIZE = 2e5; // Around 30 kilobytes
const ONE_HOUR_MS = 1000 * 60 * 60;
const HOURS_PER_EPOCH = 48;
exports.LIVE_N_EPOCHS = 3;
exports.LIFETIME_RESULT_ACCOUNT_MS = ONE_HOUR_MS * (HOURS_PER_EPOCH * exports.LIVE_N_EPOCHS); // Has to be more than 1 epoch, lets be sage
exports.LIFETIME_CONSTRUCTION_ACCOUNT_MS = ONE_HOUR_MS * (HOURS_PER_EPOCH * exports.LIVE_N_EPOCHS);
// Rent constants from https://docs.solana.com/developing/programming-model/accounts
// TODO: should this be from a dynamic value?
exports.LAMPORTS_PER_EPOCH = 19.055;
exports.MS_PER_EPOCH = ONE_HOUR_MS * HOURS_PER_EPOCH;
exports.PIDS = {
    mainnet: {
        MALLOC: "FS69YbSJbjDxTTMCco8bqP8upAP57MmFbBhQPjvnx8M7",
    },
    devnet: {
        MALLOC: "FS69YbSJbjDxTTMCco8bqP8upAP57MmFbBhQPjvnx8M7",
    },
};
